<div class="admin-layout" [class.sidebar-collapsed]="sidebarCollapsed">
  <!-- Sidebar -->
  <aside class="sidebar">
    <div class="sidebar-header">
      <img src="assets/images/Logo fondo blanco.png" alt="Khipure" class="sidebar-logo">
      <span class="badge bg-success">Ops</span>
    </div>

    <nav class="sidebar-menu">
      <a routerLink="/dashboard" routerLinkActive="active" class="menu-item">
        <i data-feather="home"></i>
        <span>Dashboard</span>
      </a>
      
      <div class="menu-section">SaaS Operations</div>
      
      <a routerLink="/metrics" routerLinkActive="active" class="menu-item">
        <i data-feather="bar-chart-2"></i>
        <span>Métricas</span>
      </a>
      
      <a routerLink="/customers" routerLinkActive="active" class="menu-item">
        <i data-feather="users"></i>
        <span>Clientes</span>
      </a>
      
      <a routerLink="/subscriptions" routerLinkActive="active" class="menu-item">
        <i data-feather="credit-card"></i>
        <span>Suscripciones</span>
      </a>
      
      <a routerLink="/activations" routerLinkActive="active" class="menu-item">
        <i data-feather="check-circle"></i>
        <span>Activaciones</span>
      </a>
      
      <a routerLink="/upgrades" routerLinkActive="active" class="menu-item">
        <i data-feather="trending-up"></i>
        <span>Upgrades</span>
      </a>
      
      <a routerLink="/coupons" routerLinkActive="active" class="menu-item">
        <i data-feather="tag"></i>
        <span>Cupones y Referidos</span>
      </a>
      
      <a routerLink="/commissions" routerLinkActive="active" class="menu-item">
        <i data-feather="dollar-sign"></i>
        <span>Comisiones</span>
      </a>
      
      <a routerLink="/catalog" routerLinkActive="active" class="menu-item">
        <i data-feather="package"></i>
        <span>Catálogo</span>
      </a>
      
      <a routerLink="/plans" routerLinkActive="active" class="menu-item">
        <i data-feather="layers"></i>
        <span>Planes y Precios</span>
      </a>
      
      <a routerLink="/modular-rules" routerLinkActive="active" class="menu-item">
        <i data-feather="sliders"></i>
        <span>Reglas Modulares</span>
      </a>
      
      <a routerLink="/payments" routerLinkActive="active" class="menu-item">
        <i data-feather="credit-card"></i>
        <span>Pagos</span>
      </a>
      
      <a routerLink="/billing-cycles" routerLinkActive="active" class="menu-item">
        <i data-feather="calendar"></i>
        <span>Ciclos de Facturación</span>
      </a>
      
      <a routerLink="/overdue" routerLinkActive="active" class="menu-item">
        <i data-feather="alert-triangle"></i>
        <span>Mora y Suspensión</span>
      </a>

      <div class="menu-section">Tickets y Soporte</div>

      <a routerLink="/support/tickets" routerLinkActive="active" class="menu-item">
        <i data-feather="life-buoy"></i>
        <span>Bandeja de Tickets</span>
      </a>

      <a routerLink="/support/categories" routerLinkActive="active" class="menu-item">
        <i data-feather="tag"></i>
        <span>Tipos de Incidencia</span>
      </a>
    </nav>

    <div class="sidebar-footer">
      <div class="user-info">
        <i data-feather="user"></i>
        <span>{{ currentUser?.displayName || 'Admin' }}</span>
      </div>
    </div>
  </aside>

  <!-- Main Content -->
  <div class="main-content">
    <!-- Navbar -->
    <header class="navbar">
      <button class="btn btn-link sidebar-toggle" (click)="toggleSidebar()">
        <i data-feather="menu"></i>
      </button>

      <div class="navbar-actions">
        <span class="user-role badge bg-primary me-3" *ngIf="currentUser">
          {{ currentUser.roles[0] }}
        </span>
        <button class="btn btn-outline-danger btn-sm" (click)="logout()">
          <i data-feather="log-out"></i> Salir
        </button>
      </div>
    </header>

    <!-- Content Area -->
    <main class="content">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
